module.exports = __webpack_public_path__ + "img/welcome1.71aa3362.png";